export default "__VITE_ASSET__CkJy6cmO__"